import { z } from 'zod';
import { ActivityRecordStateSchema } from './activity-records.schemas';
import { ProspectViewingTypeSchema } from '../deal/prospects.schemas';
import { refersTo } from '../common/refers-to';

// Workspace-addressed: the calendar is a workspace surface, and the read spans every Standort the caller may read.
export const ListMemberViewingsPathParamsSchema = z.object({ workspaceId: z.uuid() });

// One composer Besichtigung the caller is assigned, as the calendar places it (IMM-1372.3).
export const MemberViewingItemSchema = z.object({
  activityId: z.uuid(),
  prospectId: refersTo('prospect', z.uuid()),
  organizationId: refersTo('organization', z.uuid()),
  viewingType: ProspectViewingTypeSchema,
  // dueAt while OPEN, occurredAt once DONE; endsAt is startsAt + one hour.
  startsAt: z.iso.datetime(),
  endsAt: z.iso.datetime(),
  // A CANCELLED Besichtigung is never returned.
  state: ActivityRecordStateSchema.extract(['OPEN', 'DONE']),
  // „{Kontakt} · {Objekt}"; null when the Interessent resolves to no label, so the entry still shows.
  subjectLabel: z.string().nullable(),
});
export type MemberViewingItem = z.infer<typeof MemberViewingItemSchema>;

export const ListMemberViewingsResponseSchema = z.object({ items: z.array(MemberViewingItemSchema) });
export type ListMemberViewingsResponse = z.infer<typeof ListMemberViewingsResponseSchema>;
